import React from "react";
import * as Styles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/BasketList";
import * as BasketConfigCodeStyles from "./styles/BasketConfigCodeStyles";
import useConfigCode from "../../../../../hooks/summary/useConfigCode";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { BnbLabel } from "../../../../../utils/labels";
import Icon from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import type { BuildAndBuyDispatchType } from "../../../../../redux/store";
import { useBnbSelector } from "../../../../../redux/store";
import { MODAL_CONFIG_CODE } from "../../../../../utils/modalConstants";
import { showModal } from "../../../../../../../../common-deprecated/redux/actions/ModalActions";
import SrOnly from "../../../../../../../../common-deprecated/styles/v2/toyota/utilities/ScreenreaderOnly";
import { trackConfigurationCodeOpen } from "../../../../../utils/tracking";
import ImageFluid from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

const BasketConfigCode = (): JSX.Element | null => {
    const { code, showSaving, error, isMasterOrSlave, qrCode } = useConfigCode();
    const step = useBnbSelector((state) => state.navigation.step);
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    if (error) return null;

    return (
        <Styles.BasketList>
            {showSaving ? (
                <Type.SmallHeading>
                    <BnbLabel label="savingConfig" />
                </Type.SmallHeading>
            ) : (
                <>
                    <BasketConfigCodeStyles.Wrapper>
                        <div>
                            <BasketConfigCodeStyles.Label>
                                <BnbLabel label="yourCode" />
                            </BasketConfigCodeStyles.Label>
                            {!isMasterOrSlave && (
                                <Button.Link
                                    onClick={() => {
                                        trackConfigurationCodeOpen(step);
                                        dispatch(showModal({ type: MODAL_CONFIG_CODE }));
                                    }}
                                >
                                    <IconWrapper>
                                        <Icon variant="info" data-testid="info-icon" />
                                    </IconWrapper>
                                    <SrOnly>
                                        <BnbLabel label="bnbA11yButtonModalConfigOpen" />
                                    </SrOnly>
                                </Button.Link>
                            )}
                        </div>
                        <BasketConfigCodeStyles.Value>{code}</BasketConfigCodeStyles.Value>
                    </BasketConfigCodeStyles.Wrapper>
                    {isMasterOrSlave && (
                        <ImageFluid src={qrCode} alt="toyota config qr code" data-testid="imageFluid" />
                    )}
                </>
            )}
        </Styles.BasketList>
    );
};

export default BasketConfigCode;
